/*! bg-adrese.js — Област → Населено място (кирилица) pentru formularul EasySell COD, magneticshoper.com
 * Vanilla JS, fără librării. Datele (bg_locations.json = nomenclatorul Sameday 04.11.26, 5.394 localități; oraș/oblast/zip EXACT ca Sameday)
 * se încarcă leneș, doar când există formularul EasySell și clientul interacționează cu el.
 * Câmpurile ORIGINALE EasySell (city / province / zip) rămân în DOM; noi doar le scriem valorile
 * + evenimente input/change, deci EasySell trimite comanda exact ca înainte.
 */
(function () {
  'use strict';
  if (window.__bgAdreseLoaded) return;
  window.__bgAdreseLoaded = true;

  var CFG = window.BG_ADRESE || {};
  var JSON_URL = CFG.jsonUrl || '';
  var CITY_WITH_PREFIX = !!CFG.cityWithPrefix; // false => "Пловдив", true => "гр. Пловдив"
  var MAX_RESULTS = 60;
  var HINT = 'Моля, изберете населено място от списъка';

  // 28 области (ordinea alfabetică bulgară), numele scrise în câmpul „Област”
  var OBLASTS = ['Благоевград', 'Бургас', 'Варна', 'Велико Търново', 'Видин', 'Враца', 'Габрово', 'Добрич',
    'Кърджали', 'Кюстендил', 'Ловеч', 'Монтана', 'Пазарджик', 'Перник', 'Плевен', 'Пловдив', 'Разград', 'Русе',
    'Силистра', 'Сливен', 'Смолян', 'София', 'София-град', 'Стара Загора', 'Търговище', 'Хасково',
    'Шумен', 'Ямбол'];
  // Sameday: oblastul provinciei Sofia se numește „София”; clientul vede eticheta „Софийска област”
  var OBL_LABEL = { 'София': 'Софийска област' };
  function oblLabel(n) { return OBL_LABEL[n] || n; }
  // Variante pe care clientul / autofill-ul le-ar putea avea deja în câmp
  var OBL_ALIASES = { 'софия': 'София-град', 'софия град': 'София-град', 'гр. софия': 'София-град',
    'софия (столица)': 'София-град', 'столица': 'София-град', 'софийска': 'София', 'софийска област': 'София',
    'софия област': 'София', 'софия-област': 'София', 'софия (област)': 'София', 'sofia': 'София-град',
    'sofia city': 'София-град', 'sofia-grad': 'София-град', 'sofia province': 'София', 'sofia oblast': 'София' };

  // ---------- transliterare + normalizare ----------
  var TR = { 'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ж': 'zh', 'з': 'z', 'и': 'i', 'й': 'y',
    'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n', 'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u', 'ф': 'f',
    'х': 'h', 'ц': 'ts', 'ч': 'ch', 'ш': 'sh', 'щ': 'sht', 'ъ': 'a', 'ь': 'y', 'ю': 'yu', 'я': 'ya', 'ѝ': 'i', 'ё': 'yo', 'э': 'e', 'ы': 'i' };
  function translit(s, hardSign) {
    var o = '';
    for (var i = 0; i < s.length; i++) {
      var c = s.charAt(i);
      if (c === 'ъ') o += hardSign; else o += (TR[c] !== undefined ? TR[c] : c);
    }
    return o;
  }
  function skel(lat) { // aceeași reducere pe ambele părți => „sofi”→„София”, „pazardjik”→„Пазарджик”
    return lat.normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/ph/g, 'f').replace(/x/g, 'ks').replace(/q/g, 'k').replace(/w/g, 'v')
      .replace(/dzh/g, 'dj').replace(/zh/g, 'j').replace(/kh/g, 'h')
      .replace(/(ts|tz|ch|cz)/g, 'c').replace(/sh/g, 's')
      .replace(/(yu|iu|ju)/g, 'u').replace(/(ya|ia|ja)/g, 'a').replace(/y/g, 'i');
  }
  function clean(s) {
    return String(s || '').toLowerCase().replace(/ё/g, 'е').replace(/[‐-―]/g, '-')
      .replace(/^\s*(гр|с|град|село|gr|s|grad|selo)\.?\s+/, '').replace(/\s+/g, ' ').trim();
  }
  var CYR = /[а-яѝ]/;

  // ---------- date ----------
  var DATA = null, ALL = null, loading = null;
  function load() {
    if (DATA) return Promise.resolve(DATA);
    if (loading) return loading;
    if (!JSON_URL) return Promise.reject(new Error('bg-adrese: lipsă jsonUrl'));
    loading = fetch(JSON_URL, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (j) {
      ALL = [];
      Object.keys(j).forEach(function (ob) {
        j[ob].forEach(function (e, idx) {
          var bare = e.name.replace(/^(гр|с)\.\s*/, '');
          var c = bare.toLowerCase();
          var a = translit(c, 'a'), u = translit(c, 'u');
          e.oblast = ob; e.bare = bare; e.idx = idx; e.c = c;
          e.s1 = skel(a); e.s2 = skel(u);
          ALL.push(e);
        });
      });
      DATA = j;
      return j;
    });
    loading.catch(function () { loading = null; });
    return loading;
  }

  function wordStart(hay, q) {
    if (hay.indexOf(q) === 0) return 0;
    var p = hay.indexOf(' ' + q); if (p >= 0) return 1;
    p = hay.indexOf('-' + q); if (p >= 0) return 1;
    return hay.indexOf(q) >= 0 ? 2 : -1;
  }
  function search(oblast, qRaw) {
    var list = oblast && DATA[oblast] ? DATA[oblast] : ALL;
    var q = clean(qRaw);
    if (!q) return oblast ? list.slice(0, MAX_RESULTS) : [];
    var res = [];
    var cyr = CYR.test(q), qs = cyr ? q : skel(q);
    for (var i = 0; i < list.length; i++) {
      var e = list[i], sc;
      if (cyr) sc = wordStart(e.c, qs);
      else { var a = wordStart(e.s1, qs), b = wordStart(e.s2, qs); sc = a < 0 ? b : (b < 0 ? a : Math.min(a, b)); }
      if (sc >= 0) res.push([sc, e.type === 'гр.' ? 0 : 1, i, e]);
    }
    res.sort(function (x, y) { return x[0] - y[0] || x[1] - y[1] || x[2] - y[2]; });
    return res.slice(0, MAX_RESULTS).map(function (r) { return r[3]; });
  }

  // ---------- scriere în câmpurile ORIGINALE EasySell ----------
  var nativeSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
  function setOrig(input, val) {
    if (!input || input.value === val) return;
    nativeSetter.call(input, val);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // ---------- CSS ----------
  function css() {
    if (document.getElementById('bgad-css')) return;
    var st = document.createElement('style'); st.id = 'bgad-css';
    st.textContent = [
      '.bgad-orig{position:absolute!important;left:0;bottom:0;width:1px!important;height:1px!important;opacity:0!important;pointer-events:none!important;padding:0!important;border:0!important;min-width:0!important}',
      '.bgad-wrap{position:relative;flex:1 1 auto;min-width:0;display:flex}',
      '.bgad-wrap>input,.bgad-sel{width:100%;font-size:16px!important}',
      '.bgad-sel{-webkit-appearance:none;appearance:none;cursor:pointer;flex:1 1 auto;min-width:0;padding-right:28px!important;background-image:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27%3E%3Cpath d=%27M1 1l5 5 5-5%27 stroke=%27%23666%27 stroke-width=%271.6%27 fill=%27none%27/%3E%3C/svg%3E")!important;background-repeat:no-repeat!important;background-position:right 10px center!important}',
      '.bgad-sel.bgad-empty{color:#8a8a8a}',
      '.bgad-wrap .bgad-list{position:absolute;left:0;right:0;top:100%;z-index:2147483000;background:#fff;border:1px solid #cfcfcf;border-radius:8px;box-shadow:0 8px 24px rgba(0,0,0,.18);max-height:260px;overflow-y:auto;-webkit-overflow-scrolling:touch;margin-top:2px;display:none!important;text-align:left;padding:0!important}',
      '.bgad-wrap .bgad-list.bgad-open{display:block!important}',
      '.bgad-item{padding:10px 12px;cursor:pointer;font-size:15px;line-height:1.25;color:#222;border-bottom:1px solid #f1f1f1}',
      '.bgad-item:last-child{border-bottom:0}',
      '.bgad-item.bgad-act,.bgad-item:hover{background:#fff4d6}',
      '.bgad-item small{display:block;color:#777;font-size:12px;margin-top:2px}',
      '.bgad-msg{padding:10px 12px;color:#777;font-size:14px}',
      '.bgad-hint{color:#c0392b;font-size:13px;margin:4px 2px 0;line-height:1.3}'
    ].join('\n');
    document.head.appendChild(st);
  }

  // ---------- detectare câmpuri EasySell ----------
  function labelOf(inp) {
    var t = (inp.placeholder || '') + ' ' + (inp.getAttribute('aria-label') || '');
    if (inp.id) { var l = document.querySelector('label[for="' + inp.id + '"]'); if (l) t += ' ' + l.textContent; }
    return t;
  }
  function findIn(root, name, re) {
    var ins = root.querySelectorAll('input');
    for (var i = 0; i < ins.length; i++) if (ins[i].name === name) return ins[i];
    for (i = 0; i < ins.length; i++) if (ins[i].type !== 'hidden' && re.test(labelOf(ins[i]))) return ins[i];
    return null;
  }
  function rootsOf() {
    var r = document.querySelectorAll('#es-form-container, .es-form-container, #easysell form, form[class*="es-"]');
    var out = [];
    for (var i = 0; i < r.length; i++) { var dup = false; for (var j = 0; j < out.length; j++) if (out[j].contains(r[i]) || r[i].contains(out[j])) dup = true; if (!dup) out.push(r[i]); }
    return out;
  }

  // ---------- montare pe un formular ----------
  function mount(root) {
    var city = findIn(root, 'city', /Населено място|Град|City/i);
    var prov = findIn(root, 'province', /Област|Province|Region/i);
    var zip = findIn(root, 'zip', /Пощенски|Zip|Postal/i);
    if (!city || !prov) return;
    if (city.getAttribute('data-bgad') === '1' && prov.getAttribute('data-bgad') === '1') return;
    css();
    city.setAttribute('data-bgad', '1'); prov.setAttribute('data-bgad', '1');

    // codul poștal: se completează automat și se ascunde (doar dacă nu e obligatoriu în EasySell)
    if (zip && CFG.hideZip && !zip.required && zip.getAttribute('aria-required') !== 'true') {
      var gz = zip;
      while (gz.parentElement && gz.parentElement !== root && gz.parentElement.querySelectorAll('input:not([type=hidden])').length === 1) gz = gz.parentElement;
      gz.style.setProperty('display', 'none', 'important');
    }

    // ordinea vizuală: Област înaintea Населено място (doar CSS order, fără a muta noduri Vue)
    try {
      var common = city.parentElement;
      while (common && !common.contains(prov)) common = common.parentElement;
      if (common && common !== document.body) {
        var gC = city, gP = prov;
        while (gC.parentElement !== common) gC = gC.parentElement;
        while (gP.parentElement !== common) gP = gP.parentElement;
        if (gC !== gP) {
          var disp = getComputedStyle(common).display;
          if (disp.indexOf('flex') < 0) { common.style.display = 'flex'; common.style.flexDirection = 'column'; }
          var kids = common.children, ordC = 0;
          for (var k = 0; k < kids.length; k++) { kids[k].style.order = String(k * 10); if (kids[k] === gC) ordC = k * 10; }
          gP.style.order = String(ordC - 5);
        }
      }
    } catch (e) { /* ignorăm */ }

    // --- Област: <select> ---
    var sel = document.createElement('select');
    sel.className = (prov.className || '') + ' bgad-sel bgad-empty';
    sel.setAttribute('aria-label', 'Област');
    var o0 = document.createElement('option'); o0.value = ''; o0.textContent = 'Изберете област'; sel.appendChild(o0);
    OBLASTS.forEach(function (n) { var o = document.createElement('option'); o.value = n; o.textContent = oblLabel(n); sel.appendChild(o); });
    prov.classList.add('bgad-orig'); prov.setAttribute('tabindex', '-1'); prov.setAttribute('aria-hidden', 'true');
    prov.parentElement.style.position = prov.parentElement.style.position || 'relative';
    prov.parentElement.insertBefore(sel, prov.nextSibling);

    // --- Населено място: căutare + listă ---
    var wrap = document.createElement('div'); wrap.className = 'bgad-wrap';
    var inp = document.createElement('input');
    inp.type = 'text'; inp.className = (city.className || '') + ' bgad-city';
    inp.placeholder = city.placeholder || 'Населено място';
    inp.setAttribute('autocomplete', 'off'); inp.setAttribute('autocorrect', 'off'); inp.setAttribute('spellcheck', 'false');
    inp.setAttribute('role', 'combobox'); inp.setAttribute('aria-autocomplete', 'list'); inp.setAttribute('aria-expanded', 'false');
    var list = document.createElement('div'); list.className = 'bgad-list'; list.setAttribute('role', 'listbox');
    list.style.setProperty('display', 'none', 'important');
    wrap.appendChild(inp); wrap.appendChild(list);
    city.classList.add('bgad-orig'); city.setAttribute('tabindex', '-1'); city.setAttribute('aria-hidden', 'true');
    city.parentElement.style.position = city.parentElement.style.position || 'relative';
    city.parentElement.insertBefore(wrap, city.nextSibling);
    var hint = document.createElement('div'); hint.className = 'bgad-hint'; hint.style.setProperty('display', 'none', 'important'); hint.textContent = HINT;
    city.parentElement.parentElement.appendChild(hint);

    var chosen = null, items = [], act = -1, autoZip = '', blurT = null;

    function setSel(ob) {
      sel.value = ob || ''; sel.classList.toggle('bgad-empty', !ob);
      setOrig(prov, ob || '');
    }
    function showHint(on) { hint.style.setProperty('display', on ? 'block' : 'none', 'important'); }
    function close() { (list.classList.remove('bgad-open'), list.style.setProperty('display', 'none', 'important')); inp.setAttribute('aria-expanded', 'false'); act = -1; }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function render(msg) {
      if (msg) { list.innerHTML = '<div class="bgad-msg">' + esc(msg) + '</div>'; (list.classList.add('bgad-open'), list.style.setProperty('display', 'block', 'important')); return; }
      var h = '';
      items.forEach(function (e, i) {
        var sub = [];
        if (!sel.value) sub.push('обл. ' + oblLabel(e.oblast));
        if (e.dup || !sel.value) sub.push('общ. ' + e.municipality);
        if (e.zip) sub.push(e.zip);
        h += '<div class="bgad-item' + (i === act ? ' bgad-act' : '') + '" role="option" data-i="' + i + '">' + esc(e.name) +
          (sub.length ? '<small>' + esc(sub.join(' · ')) + '</small>' : '') + '</div>';
      });
      if (!items.length) h = '<div class="bgad-msg">' + (clean(inp.value) ? 'Няма намерено населено място' : 'Започнете да пишете…') + '</div>';
      list.innerHTML = h;
      (list.classList.add('bgad-open'), list.style.setProperty('display', 'block', 'important')); inp.setAttribute('aria-expanded', 'true');
    }
    function refresh() {
      if (!DATA) { render('Зареждане…'); load().then(refresh, function () { close(); }); return; }
      items = search(sel.value, inp.value); act = items.length ? 0 : -1; render();
    }
    function pick(e) {
      chosen = e;
      inp.value = e.name;
      if (sel.value !== e.oblast) setSel(e.oblast);
      setOrig(city, CITY_WITH_PREFIX ? e.name : e.bare);
      if (zip && e.zip && (!zip.value || zip.value === autoZip)) { setOrig(zip, e.zip); autoZip = e.zip; }
      showHint(false); close();
    }
    function commitFree() { // text liber: îl păstrăm, dar afișăm indicația
      var v = inp.value.trim();
      if (chosen && v === chosen.name) return;
      chosen = null;
      if (!v) { setOrig(city, ''); showHint(false); return; }
      // potrivire exactă unică => o selectăm automat
      if (DATA) {
        var q = clean(v), hits = (sel.value ? DATA[sel.value] : ALL).filter(function (e) { return e.c === q; });
        if (hits.length === 1) { pick(hits[0]); return; }
      }
      setOrig(city, v);
      if (zip && autoZip && zip.value === autoZip) { setOrig(zip, ''); autoZip = ''; }
      showHint(true);
    }

    sel.addEventListener('change', function () {
      sel.classList.toggle('bgad-empty', !sel.value);
      setOrig(prov, sel.value);
      load().catch(function () {});
      if (chosen && chosen.oblast !== sel.value) {
        chosen = null; inp.value = ''; setOrig(city, ''); showHint(false);
        if (zip && autoZip && zip.value === autoZip) { setOrig(zip, ''); autoZip = ''; }
      }
    });
    inp.addEventListener('focus', function () { clearTimeout(blurT); load().catch(function () {}); if (sel.value || clean(inp.value)) refresh(); });
    inp.addEventListener('input', function () {
      chosen = null; showHint(false);
      // textul liber ajunge imediat în câmpul EasySell (dacă clientul apasă direct „Поръчай”)
      setOrig(city, inp.value.trim());
      if (zip && autoZip && zip.value === autoZip) { setOrig(zip, ''); autoZip = ''; }
      refresh();
    });
    inp.addEventListener('keydown', function (ev) {
      var open = list.classList.contains('bgad-open');
      if (ev.key === 'ArrowDown' || ev.key === 'ArrowUp') {
        if (!open) { refresh(); return; }
        ev.preventDefault();
        if (!items.length) return;
        act = (act + (ev.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length; render();
        var el = list.querySelector('.bgad-act'); if (el) el.scrollIntoView({ block: 'nearest' });
      } else if (ev.key === 'Enter') {
        if (open && act >= 0 && items[act]) { ev.preventDefault(); pick(items[act]); }
      } else if (ev.key === 'Escape') { close(); }
    });
    inp.addEventListener('blur', function () { clearTimeout(blurT); blurT = setTimeout(function () { if (document.activeElement === inp) return; close(); commitFree(); }, 150); });
    // mousedown/touch fără a pierde focusul înainte de click
    list.addEventListener('mousedown', function (ev) { ev.preventDefault(); });
    list.addEventListener('click', function (ev) {
      var it = ev.target.closest('.bgad-item'); if (!it) return;
      var e = items[+it.getAttribute('data-i')]; if (e) pick(e);
    });
    // preîncărcare când clientul atinge formularul / deschide popup-ul
    root.addEventListener('pointerdown', function () { load().catch(function () {}); }, { once: true, passive: true });

    // valori deja existente (ex. autofill EasySell)
    var pv = (prov.value || '').trim();
    if (pv) {
      var ob = OBL_ALIASES[pv.toLowerCase()] || OBLASTS.filter(function (n) { return n.toLowerCase() === pv.toLowerCase(); })[0] || '';
      if (ob) setSel(ob);
    }
    if ((city.value || '').trim()) { inp.value = city.value.trim(); load().then(function () { commitFree(); }, function () {}); }

    // EasySell (Vue) poate re-randa inputul original; dacă dispare, re-montăm
    root.__bgad = { sel: sel, inp: inp, city: city, prov: prov, hint: hint };
  }

  function scan() {
    var roots = rootsOf();
    for (var i = 0; i < roots.length; i++) {
      var r = roots[i];
      if (r.__bgad && (!r.contains(r.__bgad.city) || !r.contains(r.__bgad.prov) || !r.contains(r.__bgad.sel) || !r.contains(r.__bgad.inp))) {
        // re-randare: curățăm resturile vechi
        [r.__bgad.sel, r.__bgad.inp && r.__bgad.inp.parentElement, r.__bgad.hint].forEach(function (n) { if (n && n.parentElement) n.parentElement.removeChild(n); });
        [r.__bgad.city, r.__bgad.prov].forEach(function (n) { if (n) { n.removeAttribute('data-bgad'); n.classList.remove('bgad-orig'); } });
        r.__bgad = null;
      }
      try { mount(r); } catch (e) { if (window.console) console.warn('bg-adrese', e); }
    }
  }
  var t = null;
  function schedule() { if (t) return; t = setTimeout(function () { t = null; scan(); }, 120); }
  function start() {
    scan();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.BG_ADRESE_DEBUG = { load: load, search: function (o, q) { return load().then(function () { return search(o, q).map(function (e) { return e.name + ' ' + e.zip; }); }); } };
})();
